import mailStore from 'owa-mail-store/lib/store/Store';
import getItemRightsManagementRestrictions from 'owa-mail-store/lib/utils/getItemRightsManagementRestrictions';
import { confirm } from 'owa-confirm-dialog';
/**
 * Confirms the specified restriction is allowed, returns true if it is, returns false and displays a confirmation dialog if it's not.
 * @param itemId The id of the item to confirm restrictions against.
 * @param restrictionToConfirm The restriction to confirm. Note: Only one restriction in this object should be true.
 * @param messageToDisplay The message to display of the action is not allowed.
 */
export default function confirmItemActionAllowed(itemId, restrictionToConfirm, messageToDisplay) {
    var itemRestrictions = getItemRightsManagementRestrictions(mailStore.items.get(itemId));
    // To protect against multiple actions being passed in, confirm all possible actions.
    // An action is confirmed if either 1. restrictionToConfirm doesn't request it, OR 2. the item allows it.
    if ((!restrictionToConfirm.PrintAllowed || itemRestrictions.PrintAllowed) &&
        (!restrictionToConfirm.ForwardAllowed || itemRestrictions.ForwardAllowed) &&
        (!restrictionToConfirm.ReplyAllowed || itemRestrictions.ReplyAllowed) &&
        (!restrictionToConfirm.ReplyAllAllowed || itemRestrictions.ReplyAllAllowed)) {
        return true;
    }
    else {
        // Show dialog indicating action is not allowed on this item/conversation
        confirm(null /* title */, messageToDisplay, false /* resolveImmediately */, {
            hideCancelButton: true,
        });
        return false;
    }
}
//# sourceMappingURL=confirmItemActionAllowed.js.map